import { render, staticRenderFns } from "./button-load.vue?vue&type=template&id=4aac50a2&"
import script from "./button-load.vue?vue&type=script&lang=js&"
export * from "./button-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports